import * as C from '../../constants';
import SkiRentalService from '../../../../services/ski/ski-rental-service';
import BookingSkiRentalService from '../../../../services/ski/booking-ski-rental-service';
import BookingService from '../../../../services/booking-service';
import exceptionValidator from '../../../../utils/exceptionValidator';

export default {

  /**
   * @param commit
   */
  resetState({ commit }) {
    commit(C.SKI_RENTAL_RESET_STATE);
  },

  /**
   * @param commit
   * @param payload
   * @returns {Promise<T>}
   */
  availableRentalProductsLoad({ commit }, payload) {
    commit(C.SKI_RENTAL_AVAILABLE_PRODUCTS_LOAD_PENDING);

    return SkiRentalService.searchAvailableSkiRentalPrices(payload)
      .then((res) => {
        commit(C.SKI_RENTAL_AVAILABLE_PRODUCTS_LOAD_SUCCESS, res.data);
      })
      .catch((error) => {
        commit(C.SKI_RENTAL_AVAILABLE_PRODUCTS_LOAD_FAILURE, error.response.data);
      });
  },

  /**
   * @param commit
   * @param bookingId
   * @returns {Promise<void>|Promise<T>}
   */
  rentalProductsByBookingIdLoad({ commit }, bookingId) {
    commit(C.SKI_RENTAL_PRODUCTS_LOAD_PENDING);

    return BookingSkiRentalService.getSkiRentalsWithProductsByBookingId(bookingId)
      .then((res) => {
        if (res.status === 200) {
          commit(C.SKI_RENTAL_PRODUCTS_LOAD_SUCCESS, res.data);
        } else {
          commit(C.SKI_RENTAL_PRODUCTS_LOAD_SUCCESS, []);
        }
      })
      .catch((error) => {
        commit(C.SKI_RENTAL_PRODUCTS_LOAD_FAILURE, error.response.data);
      });
  },

  /**
   * @param commit
   * @param dispatch
   * @param payload
   * @returns {Promise<T>}
   */
  rentalProductCreate({ commit, dispatch }, payload) {
    commit(C.SKI_RENTAL_PRODUCT_CREATE_PENDING);
    return BookingSkiRentalService.createSkiRentalWithProducts(
      payload.bookingId,
      payload.bookingParticipantId,
      payload.skiRentalProducts,
    )
      .then(() => {
        commit(C.SKI_RENTAL_PRODUCT_CREATE_SUCCESS);
        dispatch('rentalProductsByBookingIdLoad', payload.bookingId);
      })
      .catch((error) => {
        const errorMessages = exceptionValidator.parseErrorException(error, true);
        commit(C.SKI_RENTAL_PRODUCT_CREATE_FAILURE, errorMessages);
      });
  },

  /**
   * @param commit
   * @param payload
   * @returns {Promise<boolean>}
   */
  rentalParticipantUpdate({ commit }, payload) {
    commit(C.SKI_RENTAL_PARTICIPANT_UPDATE_PENDING);
    return BookingSkiRentalService.updateSkiRentalWithParticipantInfo(
      payload.skiRental,
    )
      .then(() => {
        commit(C.SKI_RENTAL_PARTICIPANT_UPDATE_SUCCESS, payload);
        return Promise.resolve(true);
      })
      .catch((error) => {
        const errorMessages = exceptionValidator.parseErrorException(error, true);
        commit(C.SKI_RENTAL_PARTICIPANT_UPDATE_FAILURE, errorMessages);
      });
  },

  /**
   * @param commit
   * @param payload
   * @returns {Promise<T>}
   */
  rentalProductSupplierRefUpdate({ commit }, payload) {
    commit(C.SKI_RENTAL_PRODUCT_SUPPLIER_REF_UPDATE_PENDING);
    return BookingSkiRentalService.updateSkiRentalProductWithSupplierRef(
      payload.skiRentalProduct.id,
      payload.supplierRef,
    )
      .then(() => {
        commit(C.SKI_RENTAL_PRODUCT_SUPPLIER_REF_UPDATE_SUCCESS, payload);
      })
      .catch((error) => {
        const errorMessages = exceptionValidator.parseErrorException(error, true);
        commit(C.SKI_RENTAL_PRODUCT_SUPPLIER_REF_UPDATE_FAILURE, errorMessages);
      });
  },

  /**
   * @param commit
   * @param payload
   * @returns {Promise<T>}
   */
  rentalProductStatusUpdate({ commit }, payload) {
    commit(C.SKI_RENTAL_PRODUCT_STATUS_UPDATE_PENDING);
    return BookingSkiRentalService.updateSkiRentalProductWithStatus(
      payload.skiRentalProductId,
      payload.status,
    )
      .then(() => {
        commit(C.SKI_RENTAL_PRODUCT_STATUS_UPDATE_SUCCESS, payload);
      })
      .catch((error) => {
        const errorMessages = exceptionValidator.parseErrorException(error, true);
        commit(C.SKI_RENTAL_PRODUCT_STATUS_UPDATE_FAILURE, errorMessages);
      });
  },

  /**
   * @param commit
   * @param dispatch
   * @param payload
   * @returns {Promise<T>}
   */
  rentalProductCancel({ commit, dispatch }, payload) {
    commit(C.SKI_RENTAL_PRODUCT_CANCEL_PENDING);
    return BookingSkiRentalService.cancelSkiRentalProduct(
      payload.skiRentalProductId,
      payload.salesAgentUserId,
    )
      .then(() => {
        commit(C.SKI_RENTAL_PRODUCT_CANCEL_SUCCESS, payload.skiRentalProductId);
        dispatch('rentalProductsByBookingIdLoad', payload.bookingId);
        window.location.reload();
      })
      .catch((error) => {
        commit(C.SKI_RENTAL_PRODUCT_CANCEL_FAILURE, error.response.data);
      });
  },

  /**
   * @param commit
   * @param dispatch
   * @param payload
   * @returns {Promise<T>}
   */
  rentalProductChangeStatus({ commit, dispatch }, payload) {
    commit(C.SKI_RENTAL_PRODUCT_CHANGE_STATUS_PENDING);
    return BookingSkiRentalService.updateSkiRentalProductWithStatus(
      payload.skiRentalProductId,
      payload.status,
    )
      .then(() => {
        commit(C.SKI_RENTAL_PRODUCT_CHANGE_STATUS_SUCCESS, payload.skiRentalProductId);
        dispatch('rentalProductsByBookingIdLoad', payload.bookingId);
      })
      .catch((error) => {
        commit(C.SKI_RENTAL_PRODUCT_CHANGE_STATUS_FAILURE, error.response.data);
      });
  },

  /**
   * @param commit
   * @param dispatch
   * @param payload
   * @returns {Promise<T>}
   */
  rentalProductStop({ commit, dispatch }, payload) {
    commit(C.SKI_RENTAL_PRODUCT_STOP_PENDING);
    return BookingSkiRentalService.stopSkiRentalProduct(
      payload.skiRentalProductId,
      payload.salesAgentUserId,
    )
      .then(() => {
        commit(C.SKI_RENTAL_PRODUCT_STOP_SUCCESS);
        dispatch('rentalProductsByBookingIdLoad', payload.bookingId);
        window.location.reload();
      })
      .catch((error) => {
        commit(C.SKI_RENTAL_PRODUCT_STOP_FAILURE, error.response.data);
      });
  },

  /**
   * @param commit
   * @param dispatch
   * @param payload
   * @returns {Promise<boolean>}
   */
  rentalProductUpdate({ commit, dispatch }, payload) {
    commit(C.SKI_RENTAL_PRODUCT_UPDATE_PENDING);
    return BookingSkiRentalService.updateSkiRentalProduct(
      {
        ...payload.changedProduct,
        participantId: payload.participantId,
      },
    )
      .then(() => {
        commit(C.SKI_RENTAL_PRODUCT_UPDATE_SUCCESS);
        dispatch('rentalProductsByBookingIdLoad', payload.bookingId);
        return Promise.resolve(true);
      })
      .catch((error) => {
        const errorMessages = exceptionValidator.parseErrorException(error, true);
        commit(C.SKI_RENTAL_PRODUCT_UPDATE_FAILURE, errorMessages);
      });
  },

  /**
   * @param commit
   * @param dispatch
   * @param payload
   * @returns {Promise<boolean>}
   */
  rentalProductPriceUpdate({ commit, dispatch }, payload) {
    commit(C.SKI_RENTAL_PRODUCT_PRICE_UPDATE_PENDING);
    return BookingSkiRentalService.updateSkiRentalProductPrice(
      payload.changedProductPrice,
    )
      .then(() => {
        commit(C.SKI_RENTAL_PRODUCT_PRICE_UPDATE_SUCCESS);
        dispatch('rentalProductsByBookingIdLoad', payload.bookingId);
        return Promise.resolve(true);
      })
      .catch((error) => {
        const errorMessages = exceptionValidator.parseErrorException(error, true);
        commit(C.SKI_RENTAL_PRODUCT_PRICE_UPDATE_FAILURE, errorMessages);
      });
  },

  /**
   * @param commit
   * @param payload
   * @returns {Promise<T>}
   */
  rentalProductDelete({ commit }, payload) {
    commit(C.SKI_RENTAL_PRODUCT_DELETE_PENDING);
    return BookingSkiRentalService.deleteSkiRentalProduct(
      payload.skiRentalProductId,
      payload.salesAgentUserId,
    )
      .then(() => {
        commit(C.SKI_RENTAL_PRODUCT_DELETE_SUCCESS, payload.skiRentalProductId);
        window.location.reload();
      })
      .catch((error) => {
        commit(C.SKI_RENTAL_PRODUCT_DELETE_FAILURE, error.response.data);
      });
  },

  /**
   * @param commit
   * @param dispatch
   * @param payload
   * @returns {Promise<any>}
   */
  rentalCancellationFeeNetUpdate({ commit, dispatch }, payload) {
    commit(C.SKI_RENTAL_CANCELLATION_FEE_NET_UPDATE_PENDING);
    return BookingSkiRentalService.updateSkiRentalCancellationFeeNet(
      payload.skiRentalProductId,
      payload.cancellationFeeNet,
    ).then(() => {
      commit(C.SKI_RENTAL_CANCELLATION_FEE_NET_UPDATE_SUCCESS);
      dispatch('rentalProductsByBookingIdLoad', payload.bookingId);
      return Promise.resolve(true);
    }).catch((error) => {
      const errorMessages = exceptionValidator.parseErrorException(error, true);
      commit(C.SKI_RENTAL_CANCELLATION_FEE_NET_UPDATE_FAILURE, errorMessages);
    });
  },

  /**
   * @param commit
   * @param bookingId
   * @returns {Promise<void>}
   */
  sendSkiRentalRequestEmail({ commit }, bookingId) {
    commit(C.SKI_RENTAL_PRODUCT_SEND_REQUEST_EMAIL_PENDING);
    return BookingSkiRentalService.sendSkiRentalRequestEmail(bookingId)
      .then(() => {
        commit(C.SKI_RENTAL_PRODUCT_SEND_REQUEST_EMAIL_SUCCESS);
      })
      .catch((error) => {
        commit(C.SKI_RENTAL_PRODUCT_SEND_REQUEST_EMAIL_FAILURE, error.response.data);
      });
  },

  /**
   * @param commit
   * @param payload
   */
  setBookingParticipant({ commit }, payload) {
    commit(C.SKI_RENTAL_SEARCH_BOOKING_PARTICIPANT_SET, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  setStartDate({ commit }, payload) {
    commit(C.SKI_RENTAL_SEARCH_START_DATE_SET, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  setNumberOfDays({ commit }, payload) {
    commit(C.SKI_RENTAL_SEARCH_NUMBER_OF_DAYS_SET, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  setLevelTypes({ commit }, payload) {
    commit(C.SKI_RENTAL_SEARCH_LEVEL_TYPES_SET, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  setSkiTypes({ commit }, payload) {
    commit(C.SKI_RENTAL_SEARCH_SKI_TYPES_SET, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  setArea({ commit }, payload) {
    commit(C.SKI_RENTAL_SEARCH_AREA_SET, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  setChangeProductBookingParticipant({ commit }, payload) {
    commit(C.SKI_RENTAL_CHANGE_PRODUCT_BOOKING_PARTICIPANT_SET, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  setChangeProductStartDate({ commit }, payload) {
    commit(C.SKI_RENTAL_CHANGE_PRODUCT_START_DATE_SET, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  setChangeProductNumberOfDays({ commit }, payload) {
    commit(C.SKI_RENTAL_CHANGE_PRODUCT_NUMBER_OF_DAYS_SET, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  setChangeProductLevelType({ commit }, payload) {
    commit(C.SKI_RENTAL_CHANGE_PRODUCT_LEVEL_TYPE_SET, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  setChangeProductSkiType({ commit }, payload) {
    commit(C.SKI_RENTAL_CHANGE_PRODUCT_SKI_TYPE_SET, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  setChangeProductPersonCategory({ commit }, payload) {
    commit(C.SKI_RENTAL_CHANGE_PRODUCT_PERSON_CATEGORY_SET, payload);
  },

  /**
   * @param commit
   * @param payload
   */
  setChangeProductPackageType({ commit }, payload) {
    commit(C.SKI_RENTAL_CHANGE_PRODUCT_PACKAGE_TYPE_SET, payload);
  },

  getPickupPlaces({ commit, rootState }) {
    commit(C.BOOKING_GET_SKI_RENTAL_PICKUP_PLACES_PENDING);
    const bookingId = rootState.booking.booking.id;
    return BookingService.getPickupPlaces({ bookingId, skiRental: true }).then((res) => {
      commit(C.BOOKING_GET_SKI_RENTAL_PICKUP_PLACES_SUCCESS, res.data);
    }).catch(() => {
      commit(C.BOOKING_GET_SKI_RENTAL_PICKUP_PLACES_FAILURE);
    });
  },

  savePickupPlace({ commit, rootState }, id) {
    commit(C.BOOKING_SAVE_SKI_RENTAL_PICKUP_PLACE_PENDING);
    const bookingId = rootState.booking.booking.id;
    return BookingService.savePickupPlaces({ bookingId, id, skiRental: true }).then(() => {
      commit(C.BOOKING_SAVE_SKI_RENTAL_PICKUP_PLACE_SUCCESS);
    }).catch(() => {
      commit(C.BOOKING_SAVE_SKI_RENTAL_PICKUP_PLACE_FAILURE);
    });
  },

  /**
   * @param commit
   * @param dispatch
   * @param payload
   * @returns {Promise<any>}
   */
  reOpen({ commit, dispatch }, payload) {
    commit(C.SKI_RENTAL_PRODUCT_CHANGE_STATUS_PENDING);

    return BookingSkiRentalService.reOpen(payload.skiRentalProductId).then(() => {
      commit(C.SKI_RENTAL_PRODUCT_CHANGE_STATUS_SUCCESS, payload.skiRentalId);
      dispatch('rentalProductsByBookingIdLoad', payload.bookingId);
    }).catch((error) => {
      commit(C.SKI_RENTAL_PRODUCT_CHANGE_STATUS_FAILURE, error.response.data);
    });
  },

  /**
   * @param commit
   * @param state
   * @param payload
   * @returns {Promise<any>}
   */
  assignParticipantToSkiPass({ commit, state }, payload) {
    commit(C.SKI_RENTAL_ASSIGN_PARTICIPANT_PENDING);
    return BookingSkiRentalService.assignParticipantToSkiPass(payload).then(() => {
      const skiRentals = JSON.parse(JSON.stringify(state.rentals.items));
      const skiRentalIndex = skiRentals.findIndex(rental => rental.id === payload.skiRentalId);
      skiRentals[skiRentalIndex].bookingParticipantId = payload.participantId;
      commit(C.SKI_RENTAL_ASSIGN_PARTICIPANT_SUCCESS, skiRentals);
    }).catch((error) => {
      commit(C.SKI_RENTAL_ASSIGN_PARTICIPANT_FAILURE, error.response.data);
    });
  },

  bookByXML({ commit, state }, payload) {
    const skiRentals = state.rentals.items;
    commit(C.SKI_RENTAL_BOOK_BY_XML_PENDING);
    return BookingSkiRentalService.bookByXML(payload).then(() => {
      commit(C.SKI_RENTAL_BOOK_BY_XML_SUCCESS, skiRentals);
    }).catch((error) => {
      commit(C.SKI_RENTAL_BOOK_BY_XML_FAILURE, error);
    });
  },

  updateSupplierRefPubnub({ commit, state }, payload) {
    const skiRentals = JSON.parse(JSON.stringify(state.rentals.items));
    const skiRentalIndex = skiRentals.findIndex(rental => rental.id === payload.id);
    skiRentals[skiRentalIndex].skiRentalProducts[0].supplierRef = payload.supplierRef;
    commit(C.SKI_RENTAL_BOOK_BY_XML_SUCCESS, skiRentals);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/rental/actions.js